import React from 'react';

const fmtMonth = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
};

const fmtYear = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '' : String(d.getFullYear()).slice(-2);
};

export default function Camps({ camps }) {
  if (!camps || camps.length === 0) return null;

  return (
    <section>
      <div className="ed-cap">
        <span className="ed-cap__label">Camps Attended</span>
      </div>

      <div className="ed-pp__card">
        {camps.map(c => (
          <div key={c.id} className="ed-pp__camp-row">
            <div className="ed-pp__datetile">
              <span className="ed-pp__datetile-month">{fmtMonth(c.date)}</span>
              <span className="ed-pp__datetile-year">{fmtYear(c.date)}</span>
            </div>

            <div className="ed-pp__camp-body">
              <div className="ed-pp__camp-name">{c.name}</div>
              {c.location && <div className="ed-pp__camp-loc">{c.location}</div>}
            </div>

            {/* Every camp in this list is attendance-verified by the query that
                built it, so a "verified" pill would carry no information.
                Camp vs clinic does. */}
            {c.event_type && (
              <span className="ed-pp__camp-pill">{c.event_type}</span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
